// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submit-product {
  background-color: #f5fbff;
}
.submit-product .form-group {
  width: 100%;
}
.submit-product .product-submit-form {
  padding: 24px;
}
.submit-product .product-image-upload-box {
  display: flex;
  flex-wrap: wrap;
  max-width: 750px;
}
.submit-product .product-image-upload-box > * {
  margin: 15px;
}
.submit-product .submit-product-label {
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #595e60;
  cursor: pointer;
}
.submit-product .form-control :hover {
  cursor: pointer;
}
.submit-product .submit-product-type {
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #a9a9ab;
}
.submit-product .form-label {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
}
.submit-product .toggle-dropdown.btn.btn-secondary {
  border-radius: 5px;
}
.submit-product .btn-actions {
  justify-content: space-evenly;
}
.submit-product .btn-actions .btn {
  margin-top: 1.25rem;
  width: 100%;
}
.submit-product .btn-actions .btn.btn-secondary {
  border-radius: 5px;
}
.submit-product .btn-actions .btn.btn-secondary:hover {
  background-color: black;
}
.submit-product .btn-actions .btn.btn-secondary:active {
  background-color: black;
}
.submit-product .btn-actions .btn.btn-secondary:focus {
  background-color: black;
}
.submit-product .btn-actions .btn.btn-primary {
  border-radius: 5px;
}
.submit-product .btn-actions .btn-primary:disabled {
  cursor: default;
}
.submit-product .add-product-image-container {
  width: 12rem;
  height: 12rem;
  border: 1px solid #414b4f;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  position: relative;
}
.submit-product .add-product-image-container .font-awesome-icon {
  background-color: #f5fbff;
  cursor: pointer;
}
.submit-product .add-product-image-container .add-product-image {
  width: 98%;
  height: 98%;
  object-fit: cover;
  overflow: hidden;
  border-radius: 5px;
  display: block;
}
.submit-product .add-product-image-container .add-product-clear-icon {
  position: absolute;
  top: 0;
  right: 0;
  color: red;
  padding: 5px;
  z-index: 1;
  cursor: pointer;
}
.submit-product .add-product-image-container--invalid {
  width: 12rem;
  height: 12rem;
  border: 1px solid red;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  position: relative;
  box-shadow: 0 0 5px 5px rgba(241, 22, 70, 0.3);
  transition: box-shadow 0.5s;
}
.submit-product .add-product-image-container--invalid .font-awesome-icon {
  background-color: #f5fbff;
  cursor: pointer;
}
.submit-product .add-product-image-container--invalid .add-product-image {
  width: 98%;
  height: 98%;
  object-fit: cover;
  overflow: hidden;
  border-radius: 5px;
  display: block;
}
.submit-product .add-product-image-container--invalid .add-product-clear-icon {
  position: absolute;
  top: 0;
  right: 0;
  color: red;
  padding: 5px;
  z-index: 1;
  cursor: pointer;
}
.submit-product .add-product-image-container--dashed {
  width: 12rem;
  height: 12rem;
  border: 1px dashed #414b4f;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  position: relative;
}
.submit-product .add-product-image-container--dashed .font-awesome-icon {
  background-color: #f5fbff;
  cursor: pointer;
}
.submit-product .add-product-image-container--dashed .add-product-image {
  width: 98%;
  height: 98%;
  object-fit: cover;
  overflow: hidden;
  border-radius: 5px;
  display: block;
}
.submit-product .add-product-image-container--dashed .add-product-clear-icon {
  position: absolute;
  top: 0;
  right: 0;
  color: red;
  padding: 5px;
  z-index: 1;
  cursor: pointer;
}
.submit-product .submit-product-title {
  margin: 0 13px 6px 0;
  font-family: "Open Sans";
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
  text-align: left;
  color: #595e60;
}
.submit-product .submit-product-sub-title {
  margin: 6px 0 15px;
  font-family: "Open Sans";
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  color: #595e60;
}
.submit-product .submit-product-image-label {
  flex-grow: 0;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-align: left;
  color: #414b4f;
}
.submit-product .pad-t-120 {
  padding-top: 120px;
}
.submit-product .pt-80 {
  padding-top: 80px;
}
.submit-product .character-count {
  background-color: red;
}
.submit-product .p-50 {
  padding: 50px;
}

.submit-product-error-message {
  color: #ef6360;
}`, "",{"version":3,"sources":["webpack://./src/pages/safe-list/SubmitProduct.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;AADF;AAEE;EACE,WAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAIE;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAII;EACE,YAAA;AAFN;AAME;EACE,YAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAJJ;AAQI;EACE,eAAA;AANN;AAUE;EACE,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAcE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAZJ;AAeE;EACE,kBAAA;AAbJ;AAgBE;EACE,6BAAA;AAdJ;AAgBI;EACE,mBAAA;EACA,WAAA;AAdN;AAeM;EACE,kBAAA;AAbR;AAcQ;EACE,uBAAA;AAZV;AAcQ;EACE,uBAAA;AAZV;AAcQ;EACE,uBAAA;AAZV;AAgBM;EACE,kBAAA;AAdR;AAkBI;EACE,eAAA;AAhBN;AAoBE;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,yBAAA;EACA,eAAA;AAlBN;AAqBI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAnBN;AAsBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AApBN;AAwBE;EACE,YAAA;EACA,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,8CAAA;EACA,2BAAA;AAtBJ;AAwBI;EACE,yBAAA;EACA,eAAA;AAtBN;AAyBI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAvBN;AA0BI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AAxBN;AA4BE;EACE,YAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AA1BJ;AA4BI;EACE,yBAAA;EACA,eAAA;AA1BN;AA6BI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AA3BN;AA8BI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;AA5BN;AAgCE;EACE,oBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA9BJ;AAiCE;EACE,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AA/BJ;AAkCE;EACE,YAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAhCJ;AAmCE;EACE,kBAAA;AAjCJ;AAoCE;EACE,iBAAA;AAlCJ;AAqCE;EACE,qBAAA;AAnCJ;AAsCE;EACE,aAAA;AApCJ;;AAwCA;EACE,cC3OW;ADsMb","sourcesContent":["@import '../../styles/colors.scss';\n\n.submit-product {\n  background-color: #f5fbff;\n  .form-group {\n    width: 100%;\n  }\n\n  .product-submit-form {\n    padding: 24px;\n  }\n\n  .product-image-upload-box {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 750px;\n\n    &>* {\n      margin: 15px;\n    }\n  }\n\n  .submit-product-label {\n    flex-grow: 0;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    text-align: left;\n    color: #595e60;\n    cursor: pointer;\n  }\n\n  .form-control {\n    :hover {\n      cursor: pointer;\n    }\n  }\n\n  .submit-product-type {\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    text-align: left;\n    color: #a9a9ab;\n  }\n\n  .form-fields {\n  }\n\n  .form-label {\n    font-family: 'Open Sans';\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 150%;\n  }\n\n  .toggle-dropdown.btn.btn-secondary {\n    border-radius: 5px;\n  }\n\n  .btn-actions {\n    justify-content: space-evenly;\n\n    .btn {\n      margin-top: 1.25rem;\n      width: 100%;\n      &.btn-secondary {\n        border-radius: 5px;\n        &:hover {\n          background-color: black;\n        }\n        &:active {\n          background-color: black;\n        }\n        &:focus {\n          background-color: black;\n        }\n      }\n\n      &.btn-primary {\n        border-radius: 5px;\n      }\n    }\n\n    .btn-primary:disabled {\n      cursor: default;\n    }\n  }\n\n  .add-product-image-container {\n    width: 12rem;\n    height: 12rem;\n    border: 1px solid #414b4f;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n    position: relative;\n\n    .font-awesome-icon {\n      background-color: #f5fbff;\n      cursor: pointer;\n    }\n\n    .add-product-image {\n      width: 98%;\n      height: 98%;\n      object-fit: cover;\n      overflow: hidden;\n      border-radius: 5px;\n      display: block;\n    }\n\n    .add-product-clear-icon {\n      position: absolute;\n      top: 0;\n      right: 0;\n      color: red;\n      padding: 5px;\n      z-index: 1;\n      cursor: pointer;\n    }\n  }\n\n  .add-product-image-container--invalid {\n    width: 12rem;\n    height: 12rem;\n    border: 1px solid red;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n    position: relative;\n    box-shadow: 0 0 5px 5px rgba(241, 22, 70, 0.3);\n    transition: box-shadow 0.5s;\n\n    .font-awesome-icon {\n      background-color: #f5fbff;\n      cursor: pointer;\n    }\n\n    .add-product-image {\n      width: 98%;\n      height: 98%;\n      object-fit: cover;\n      overflow: hidden;\n      border-radius: 5px;\n      display: block;\n    }\n\n    .add-product-clear-icon {\n      position: absolute;\n      top: 0;\n      right: 0;\n      color: red;\n      padding: 5px;\n      z-index: 1;\n      cursor: pointer;\n    }\n  }\n\n  .add-product-image-container--dashed {\n    width: 12rem;\n    height: 12rem;\n    border: 1px dashed #414b4f;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 5px;\n    position: relative;\n\n    .font-awesome-icon {\n      background-color: #f5fbff;\n      cursor: pointer;\n    }\n\n    .add-product-image {\n      width: 98%;\n      height: 98%;\n      object-fit: cover;\n      overflow: hidden;\n      border-radius: 5px;\n      display: block;\n    }\n\n    .add-product-clear-icon {\n      position: absolute;\n      top: 0;\n      right: 0;\n      color: red;\n      padding: 5px;\n      z-index: 1;\n      cursor: pointer;\n    }\n  }\n\n  .submit-product-title {\n    margin: 0 13px 6px 0;\n    font-family: 'Open Sans';\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 1.5;\n    text-align: left;\n    color: #595e60;\n  }\n\n  .submit-product-sub-title {\n    margin: 6px 0 15px;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    line-height: 1.5;\n    text-align: left;\n    color: #595e60;\n  }\n\n  .submit-product-image-label {\n    flex-grow: 0;\n    font-family: 'Open Sans';\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.5;\n    text-align: left;\n    color: #414b4f;\n  }\n\n  .pad-t-120 {\n    padding-top: 120px;\n  }\n\n  .pt-80 {\n    padding-top: 80px; \n  }\n\n  .character-count {\n    background-color: red;\n  }\n\n  .p-50 {\n    padding: 50px;\n  }\n}\n\n.submit-product-error-message {\n  color: $form-error;\n}\n","$site-text: #00171f;\n$safe-list: #8e8e93;\n$trans-white: rgba(255, 255, 255, 0.5);\n$trans-grey: rgba(211, 211, 211, 0.5);\n$disabled-link: rgba(142, 142, 147, 0.15);\n$white: #ffffff;\n$page-background: #f5fbff;\n\n$link: #007ea7;\n$font-awesome-icon-color: #85a3ad;\n\n// Buttons\n$btn-color-white: #ffffff;\n$btn-primary: #00889b;\n$secondary: #9db6be;\n$favorite-star: #f9a825;\n\n// Forms\n$form-control-border: #e7edef;\n$form-color: #85a3ad;\n$form-error: #ef6360;\n\n//text color\n$text-normal: #414b4f;\n\n//primary\n$primary-color: #00889b;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
